import { EMyVModeType } from "@/types/backoffice/dto/myv/myv-mode-type-dto.ts";
import { EMyVPRogrammingType } from "@/types/backoffice/dto/myv/myv-programming-type-dto.ts";
import { EMyVPlanningMode } from "@/types/backoffice/dto/myv/planning-mode-dto";

const myvLocale = {
  myv: {
    programming: {
      type: {
        [EMyVPRogrammingType.DEFAULT]: "Défaut",
        [EMyVPRogrammingType.USER]: "Programme",
        [EMyVPRogrammingType.QUICK]: "Rapide",
        [EMyVPRogrammingType.MANUAL]: "Manuel",
        [EMyVPRogrammingType.UNKNOWN]: "Inconnu",
        [EMyVPRogrammingType.ERROR]: "Erreur",
      },
      mode: {
        [EMyVModeType.NORMAL]: "Marche",
        [EMyVModeType.CONFORT]: "Confort",
        [EMyVModeType.CONFORTMINUS1]: "Confort -1",
        [EMyVModeType.CONFORTMINUS2]: "Confort -2",
        [EMyVModeType.ECO]: "Eco",
        [EMyVModeType.ECOV]: "Eco V",
        [EMyVModeType.HORS_GEL]: "Hors Gel",
        [EMyVModeType.TEMPERATURE]: "Temperature",
        [EMyVModeType.ARRET]: "Stop",
        [EMyVModeType.UNKNOWN]: "Inconnu",
        [EMyVModeType.ERROR]: "Erreur",
      },
      planningMode: {
        [EMyVPlanningMode.NORMAL]: "Marche",
        [EMyVPlanningMode.ECO]: "Eco",
        [EMyVPlanningMode.TEMPERATURE]: "Temperature",
        [EMyVPlanningMode.COMFORT_ON]: "Confort",
        [EMyVPlanningMode.COMFORT_1]: "Confort",
        [EMyVPlanningMode.COMFORT_2]: "Confort",
        [EMyVPlanningMode.NO_FROST]: "Hors Gel",
        [EMyVPlanningMode.STOP]: "Stop",
        [EMyVPlanningMode.ECO_V]: "Eco V",
        [EMyVPlanningMode.UNKNOWN]: "Inconnu",
      },
    },
  },
};

export type MyvLocale = typeof myvLocale;
export default myvLocale;
